module.exports = "<nv-react-component component=\"LearningJourney\"></nv-react-component>";